import ReactDOM from 'react-dom';
import React from 'react';
import { createApolloClientPage, ApolloProvider, initializeI18N } from '@aperza/app-base';
import AppFormPageLoader from './AppFormPageLoader';
initializeI18N();
const apolloClient = createApolloClientPage('aperza-app-formpage');
export const start = () => {
    let element = document.getElementById('aperza-app');
    if (element) {
        let companyContractDisplayId = parseInt(element.dataset.companyContractDisplayId);
        let formHashPath = element.dataset.formHashPath;
        if (companyContractDisplayId && formHashPath) {
            ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
                React.createElement(AppFormPageLoader, { companyContractDisplayId: companyContractDisplayId, formHashPath: formHashPath })), element);
        }
    }
};
